import { useCallback } from 'react';
import { debounce } from 'lodash';
import { SuggestionDataItem } from 'react-mentions';

import { useQueryClient } from '@tanstack/react-query';

import { indexTaggableUsers, TaggableUserResource } from 'services/api/taggableUsers';

export default function useTaggableUsersQuery(resource: TaggableUserResource | undefined) {
  const queryClient = useQueryClient();

  const fetchTaggableUsers = useCallback(
    async (search: string, callback: (data: SuggestionDataItem[]) => void) => {
      if (!resource) return callback([]);

      const queryKey = ['taggableUsers', { ...resource, search }];
      const queryFn = ({ signal }) => indexTaggableUsers({ ...resource, pageSize: 25, search }, signal);

      queryClient.fetchQuery({ queryKey, queryFn }).then((response) => callback(response.data));
    },
    [resource, queryClient]
  );

  // `indexTaggableUsers` has deps that are unknown to this callback hook so it throws a benign warning
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(debounce(fetchTaggableUsers, 250), [fetchTaggableUsers]);
}
